import { useContext, useEffect, useState } from 'react';
import { FaTrash, FaStar } from 'react-icons/fa';

import AdminModal from '../../admin-modal/admin-modal.component';
import Button from '../../button/button.component';
import Spinner from '../../spinner/spinner.component.jsx';

import { ConfigurationContext } from '../../../../contexts/configuration.context.jsx';

import { api } from '../../../../config.js';

import {
  GalleryContainer,
  MainImageContainer,
  MainImage,
  ThumbnailGrid,
  Thumbnail,
  MainImageDeleteButton,
  MainImageActiveButton
} from './imgae-gallery.styles';

const ImageGallery = ({ images = [], pictureSize = '', onDelete = () => {}, onSetActive = null }) => {
  const [activeImage, setActiveImage] = useState(images[0] || null);
  const [currentImagePath, setCurrentImagePath] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { configuration, squareLogo } = useContext(ConfigurationContext);

  useEffect(() => {
    if (activeImage) {
      setCurrentImagePath(`${api}${activeImage.path || activeImage.url}${pictureSize}`);
      return
    }

    if (!activeImage && squareLogo) {
      setCurrentImagePath(api + squareLogo.path + '.webp');
      return
    }
  }, [activeImage, squareLogo]);

  const handleDelete = () => {
    if (activeImage?.id) {
      onDelete(activeImage.id);
      setShowDeleteModal(false);
    }
  };

  const handleSetActive = () => {
    if (activeImage?.id && typeof onSetActive === 'function') {
      onSetActive(activeImage);
    }
  };

  const isImageActive = (img) => img?.metadata?.active === true;

  return (
    <GalleryContainer>
      {!configuration ?
        <Spinner />
      :
        <>
          <AdminModal
            show={showDeleteModal}
            setShow={setShowDeleteModal}
            title="Delete Image"
            image={''}
            message={`Are you sure you want to delete this image?`}
            cancelText="Cancel"
            action={handleDelete}
            actionText="Delete"
          />

          <MainImageContainer>
            <MainImage
              src={currentImagePath}
              alt="Displayed Image"
            />
            {activeImage && (
              <>
                <MainImageDeleteButton
                  onClick={() => setShowDeleteModal(true)}
                  title="Delete Image"
                >
                  <FaTrash size={14} />
                </MainImageDeleteButton>
                {isImageActive(activeImage) && (
                  <MainImageActiveButton
                    title="Currently Active Logo"
                  >
                    <FaStar size={14} />
                  </MainImageActiveButton>
                )}
              </>
            )}
          </MainImageContainer>

          {images.length > 1 && (
            <ThumbnailGrid>
              {images.map((img, idx) => (
                <div key={idx} style={{ position: 'relative' }}>
                  <Thumbnail
                    src={`${api}${img.path || img.url}${pictureSize}`}
                    onClick={() => setActiveImage(img)}
                    isActive={activeImage?.path === (img.path || img.url)}
                    alt={`Thumbnail ${idx + 1}`}
                  />
                  {isImageActive(img) && (
                    <FaStar
                      size={12}
                      color="#007bff"
                      style={{ position: 'absolute', top: 2, right: 2 }}
                      title="Active Logo"
                    />
                  )}
                </div>
              ))}
            </ThumbnailGrid>
          )}

          {onSetActive && activeImage && !isImageActive(activeImage) && (
            <div style={{ marginTop: '1rem' }}>
              <Button onClick={handleSetActive}>Set as Active Logo</Button>
            </div>
          )}
        </>
      }
    </GalleryContainer>
  );
};

export default ImageGallery;